import React, { useEffect, useState } from "react";
import { getSocketAdmin, getSocketUser  } from "../../services/socket";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";

function NotificationListener() {
  const [notifications, setNotifications] = useState([]);
  const { i18n } = useTranslation("global");
  const language = i18n.language || 'es';

  useEffect(() => {
    const handleNotification = (notification) => {
      try {
        if (notification && 
          notification.id &&
          notification.title_en &&
          notification.title_es &&
          notification.description_en &&
          notification.description_es &&
          notification.category_id) {
        
        const normalizedNotification = {
          id: notification.id,
          title_en: notification.title_en,
          title_es: notification.title_es,
          description_en: notification.description_en,
          description_es: notification.description_es,
          category_id: notification.category_id,
          is_global: notification.is_global,
          created_at: notification.created_at || new Date().toISOString(),
        };

          setNotifications((prev) => [...prev, normalizedNotification]);
          
          setTimeout(() => {
            setNotifications((prev) => prev.filter((n) => n.id !== normalizedNotification.id));
          }, 30000);
        }
      } catch (error) {
        console.error("Error al procesar la notificación:", error);
      }
    };

    const socketAdmin = getSocketAdmin();

    socketAdmin?.on("notification", handleNotification);

    return () => {
      socketAdmin?.off("notification", handleNotification);
    };
  }, []);

  const handleClose = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const getSeverity = (category_id) => {
    switch (category_id) {
      case 1: return "info";
      case 2: return "warning";
      case 3: return "error";
      case 4: return "success";
      default: return "info";
    }
  };

  const getLocalizedNotification = (notification) => {
    const isEnglish = language === 'en';
    return {
      title: isEnglish ? notification.title_en : notification.title_es,
      description: isEnglish ? notification.description_en : notification.description_es,
    };
  };

  return (
    <Stack
      spacing={2}
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        maxWidth: '500px',
        marginBottom: "10px",
        marginLeft: "10px",
        marginRight: "40px"
      }}
    >
      {notifications.map((notification) => {
        const localizedNotification = getLocalizedNotification(notification);

        return (
          <Alert
            key={notification.id}
            severity={getSeverity(notification.category_id)}
            onClose={() => handleClose(notification.id)}
            sx={{ textAlign: 'left', width: '100%' }}
          >
            <AlertTitle>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                {localizedNotification.title}
              </Typography>
            </AlertTitle>
            {localizedNotification.description}
          </Alert>
        );
      })}
    </Stack>
  );
}

export default NotificationListener;